import { VALIDATE_CHARACTER } from "common/Constants"; 

export const EligibleList = [
  "Both",
  "Male",
  "Female",
];

const DoYouWant = [
  "Yes",
  "No"
]
export const getEditLeaveJson = (data, LeaveList) => {
  const EditLeaveForm = {
    totalpages: 1,
    pages: [
      {
        modalView: false,
        colSpan: [24, 24, 24],
        fields: [
          // Row 1
          [
            {
              id: 1,
              label: "Leave Name",
              type: "text",
              name: "leaveCategoryName",
              Placeholder: "Leave Name",
              value: data["leaveCategoryName"],
              validationRules: [
                {
                  required: true,
                  message: `Please enter your Leave Name`,
                },
                {
                  validator: (rule, value, callback) => {
                    if (value && !VALIDATE_CHARACTER.test(value)) {
                      callback("Leave Name should not contain special characters");
                    } else {
                      callback();
                    }
                  },
                },
                {
                  validator: (rule, value) => {
                      if (LeaveList.some((data) => data.leaveCategoryName === value)) {
                        return Promise.reject("Leave already exists");
                      }
                    
                    return Promise.resolve();
                  },
                },
              ],
            },

          ],
          [
            {
              id: 2,
              label: "Number of Days",
              type: "text",
              name: "numberOfLeaves",
              Placeholder: "Number of Days",
              value: data["numberOfLeaves"],
              validationRules: [
                {
                  required: true,
                  message: `Please enter your Number of Days`,
                },
              ],
            },

          ],
          [
            {
              id: 3,
              label: "Eligible",
              type: "radio",
              name: "eligible",
              Placeholder: "Select",
              value: "",
              options: EligibleList,
              validationRules: [
                {
                  required: true,
                  message: `Please select the eligible`,
                },
              ],
            },
          ],
          [
            {
              id: 4,
              label: "Do you want to include Saturdays in this leave?",
              type: "radio",
              name: "isSaturday",
              Placeholder: "Select",
              value: "",
              options: DoYouWant,
              validationRules: [
                {
                  required: true,
                  message: `Please select`,
                },
              ],
            },
          ],
          [
            {
              id: 4,
              label: "Do you want to include Sundays in this leave?",
              type: "radio",
              name: "weekend",
              Placeholder: "Select",
              value: "",
              options: DoYouWant,
              validationRules: [
                {
                  required: true,
                  message: `Please select`,
                },
              ],
            },
          ],
          [
            {
              id: 5,
              label: `Do you want to include the "Holidays" you provide in this leave?`,
              type: "radio",
              name: "holiday",
              Placeholder: "Select",
              value: "",
              options: DoYouWant,
              validationRules: [
                {
                  required: true,
                  message: `Please select`,
                },
              ],
            },
          ],
           [
            {
              id: 10,
              label: "Do you want to include Reliever?",
              type: "radio",
              name: "reliever",
              Placeholder: "Select",
              value: "",
              options: DoYouWant,
              validationRules: [
                {
                  required: true,
                  message: "Please select",
                },
              ],
            },
          ],
        ],
      },
    ],
  }

  return {
    EditLeaveForm,
  }
}
